<form novalidate>
  <nsc-card>
    <nsc-card-title shoppingCartCount="3">Pending Order Details</nsc-card-title>
    <nsc-card-content>
      <div class="row nsc-row--20 align-items-center">
        <div class="col-auto">
          <button
            mat-raised-button
            id="orderreview_Addrecepient"
            class="nsc-button"
            type="button"
            color="primary"
            [disabled]="content.recipients.length >= values.maxRecipients"
            (click)="addRecipient()">Add Recipient <mat-icon>add_circle_outline</mat-icon></button>
          </div>
          @if (content.recipients.length >= values.maxRecipients) {
            <div class="col">
              <span class="mat-error ">You have reached the maximum number of recipients. Please complete your order.</span>
            </div>
          }
          @if (content.recipients.length === 0) {
            <div class="col">
              <span class="mat-error ">You have not selected any recipients for your transcript(s).</span>
            </div>
          }
        </div>

        <nsc-spacer size="lg"></nsc-spacer>

        @for (recipient of content.recipients; track recipient; let i = $index) {
          <div>
            <nsc-recipient-details
              [recipient]="recipient"
              (editRecipient)="editRecipient(i)"
              (deleteRecipient)="deleteRecipient(i)">
            </nsc-recipient-details>
            @if (i < content.recipients.length - 1) {
              <nsc-spacer size="xs"></nsc-spacer>
            }
            @if (i < content.recipients.length - 1) {
              <hr class="nsc-hr">
            }
            @if (i < content.recipients.length - 1) {
              <nsc-spacer size="xs"></nsc-spacer>
            }
          </div>
        }

        <nsc-spacer size="md"></nsc-spacer>

        @if (content.totalFees > 0) {
          <div class="row justify-content-end">
            <div class="col-auto">
              <div class=" mat-elevation-z1 nsc-order-total">
                Total Fee for Order: <strong>{{ content.totalFees | currency }}</strong>
              </div>
            </div>
          </div>
        }
      </nsc-card-content>
    </nsc-card>

    <nsc-spacer size="md"></nsc-spacer>
    @if (isConsentWavied) {
      <nsc-card>
        <nsc-card-title>Consent Confirmation</nsc-card-title>
        <nsc-card-content>
          <nsc-form-field-toggle idx="consent_confirmation" controlName="consentConfirmation" label="By completing this order, I confirm that I am requesting my own academic transcript and that the information I have provided is accurate. I authorize the delivery or transmission of my transcript to the destination I have chosen for the purpose of completing my order. The information I have provided, including without limitation my social security number or student ID if I have provided it, may be used to match my identity to my institution's education records."
            [group]="formGroup">
          </nsc-form-field-toggle>
        </nsc-card-content>
      </nsc-card>
    }

    <nsc-spacer size="md"></nsc-spacer>

    <div class="nsc-form-actions">
      <button
        mat-stroked-button
        id="orderreview_cancel"
        class="nsc-form-actions__button button-big"
        color="primary"
        type="button"
      (click)="cancel()">Cancel Order</button>
      <nsc-spacer horizontal="true" size="md"></nsc-spacer>
      <button
        mat-raised-button
        id="orderreview_checkout"
        class="nsc-form-actions__button nsc-btn__right button-big"
        color="primary"
        type="button"
        [disabled]="disableCheckout()"
        (click)="continue()">Checkout @if ((content.recipients.length !== 0 && !values.isRequiredFieldNull)) {
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      }</button>
    </div>
  </form>

